import { AtlasV2SalesSummaryPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2SalesSummaryPageLayout';
import { AtlasV2SalesUnitsSoldPageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasV2SalesUnitsSoldPageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasV2SalesPageLayout({ metricType }) {
  const salesPageLayouts = {
    retailSales: AtlasV2SalesSummaryPageLayout,
    unitsSold: AtlasV2SalesUnitsSoldPageLayout
  };
  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'AtlasV2salesPageLayout',
        CustomComponent: salesPageLayouts[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
